(function () {
  'use strict';
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isTouchDevice = window.matchMedia('(hover: none)').matches;

  function initScrollReveal(section) {
    const cards = section.querySelectorAll('.velmora-category-card');
    if (!cards.length) return;
    if (prefersReducedMotion) {
      cards.forEach(c => { c.style.opacity = '1'; c.style.transform = 'none'; });
      return;
    }
    cards.forEach(c => c.classList.add('velmora-reveal-pending'));
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.remove('velmora-reveal-pending');
          entry.target.classList.add('velmora-reveal-done');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    cards.forEach(c => observer.observe(c));
  }

  function initTilt(card) {
    if (prefersReducedMotion || isTouchDevice) return;
    const maxTilt = 8;
    let rafId, targetRX = 0, targetRY = 0, currentRX = 0, currentRY = 0;

    function loop() {
      currentRX += (targetRX - currentRX) * 0.1;
      currentRY += (targetRY - currentRY) * 0.1;
      card.style.transform = `rotateX(${currentRX}deg) rotateY(${currentRY}deg) translateZ(0)`;
      rafId = requestAnimationFrame(loop);
    }

    card.addEventListener('mouseenter', () => { rafId = requestAnimationFrame(loop); });
    card.addEventListener('mousemove', e => {
      const r = card.getBoundingClientRect();
      targetRY = ((e.clientX - r.left) / r.width - 0.5) * maxTilt * 2;
      targetRX = -((e.clientY - r.top) / r.height - 0.5) * maxTilt * 2;
    });
    card.addEventListener('mouseleave', () => {
      targetRX = 0; targetRY = 0;
      setTimeout(() => {
        cancelAnimationFrame(rafId);
        card.style.transform = 'rotateX(0deg) rotateY(0deg) translateZ(0)';
        card.style.transition = 'transform 0.5s cubic-bezier(0.25,0.46,0.45,0.94)';
        setTimeout(() => { card.style.transition = ''; }, 500);
      }, 400);
    });
  }

  function enhanceCard(card) {
    card.classList.add('velmora-category-card');
    if (!card.querySelector('.velmora-card-shine')) {
      const shine = document.createElement('div');
      shine.className = 'velmora-card-shine';
      shine.setAttribute('aria-hidden', 'true');
      card.appendChild(shine);
    }
    const parent = card.parentElement;
    if (parent && !parent.classList.contains('velmora-card-wrap')) {
      const wrap = document.createElement('div');
      wrap.className = 'velmora-card-wrap';
      parent.insertBefore(wrap, card);
      wrap.appendChild(card);
    }
    initTilt(card);
  }

  function init() {
    // ⚠️ 重要：把下面的选择器替换成你的分类卡片实际 class 名
    const section = document.querySelector('[id*="1786539412c129ea33"]');
    if (!section) return;
    section.classList.add('velmora-category-section');

    // 查看你的 Liquid 文件后，把 '.your-actual-card-class' 替换成真实的卡片 class
    const cards = section.querySelectorAll('.category-card, .collection-card, [class*="category__item"], [class*="collection__item"]');
    cards.forEach(enhanceCard);
    initScrollReveal(section);
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
